import * as React from 'react'
import { MenuContent } from '~components/MenuContent'
import * as css from './DMContent.css'

export interface DMContentProps {
  variant?: 'menu' | 'horizontal'
  align?: 'start' | 'center' | 'end'
  sideOffset?: number
  children: React.ReactNode
}

export function DMContent({
  sideOffset = 8,
  children,
  align,
  variant,
}: DMContentProps): JSX.Element {
  return (
    <div className={css.root}
      data-align={align}
      data-side-offset={sideOffset}
    >
      <MenuContent className={css.menuContent} variant={variant}>{children}</MenuContent>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/DropdownMenu/DMContent.tsx